import script from "./ChangeVideoCaptionStatusModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./ChangeVideoCaptionStatusModal.vue?vue&type=script&lang=ts&setup=true"

import "./ChangeVideoCaptionStatusModal.vue?vue&type=style&index=0&id=db742ab0&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-db742ab0"]])

export default __exports__